import {
    PROBLEM_LISTS_FETCH_SUCCESS,
    PROBLEM_LISTS_FETCH_RESET
} from "../actions/types";


const INIT_STATE = {
    problemLists: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PROBLEM_LISTS_FETCH_SUCCESS: {
            return {
                ...state,
                problemLists: action.payload
            };
        }
        case PROBLEM_LISTS_FETCH_RESET: {
            return {
                ...state,
                problemLists: []
            }
        }
        default:
            return state;
    }
};